/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { farmControllerCreate } from '../fn/farm/farm-controller-create';
import { FarmControllerCreate$Params } from '../fn/farm/farm-controller-create';
import { farmControllerDelete } from '../fn/farm/farm-controller-delete';
import { FarmControllerDelete$Params } from '../fn/farm/farm-controller-delete';
import { farmControllerFindAll } from '../fn/farm/farm-controller-find-all';
import { FarmControllerFindAll$Params } from '../fn/farm/farm-controller-find-all';
import { farmControllerFindById } from '../fn/farm/farm-controller-find-by-id';
import { FarmControllerFindById$Params } from '../fn/farm/farm-controller-find-by-id';
import { farmControllerSearch } from '../fn/farm/farm-controller-search';
import { FarmControllerSearch$Params } from '../fn/farm/farm-controller-search';
import { farmControllerUpdate } from '../fn/farm/farm-controller-update';
import { FarmControllerUpdate$Params } from '../fn/farm/farm-controller-update';
import { FarmDto } from '../models/farm-dto';
import { PageInfoDto } from '../models/page-info-dto';

@Injectable({ providedIn: 'root' })
export class FarmService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `farmControllerSearch()` */
  static readonly FarmControllerSearchPath = '/api/farm';

  /**
   * 농가 목록 조회.
   *
   * 농가 목록을 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmControllerSearch$Response(params: FarmControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<FarmDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = farmControllerSearch(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 농가 목록 조회.
   *
   * 농가 목록을 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmControllerSearch(params: FarmControllerSearch$Params, context?: HttpContext): Observable<{
'items': Array<FarmDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.farmControllerSearch$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<FarmDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<FarmDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `farmControllerCreate()` */
  static readonly FarmControllerCreatePath = '/api/farm';

  /**
   * 농가 등록.
   *
   * 새로운 농가를 등록합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmControllerCreate$Response(params: FarmControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmDto>> {
    const obs = farmControllerCreate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 농가 등록.
   *
   * 새로운 농가를 등록합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmControllerCreate(params: FarmControllerCreate$Params, context?: HttpContext): Observable<FarmDto> {
    const resp = this.farmControllerCreate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FarmDto>): FarmDto => r.body)
    );
  }

  /** Path part for operation `farmControllerFindAll()` */
  static readonly FarmControllerFindAllPath = '/api/farm/all';

  /**
   * 전체 농가 목록 조회.
   *
   * 전체 농가 목록을 조회합니다. (드롭다운용)
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmControllerFindAll$Response(params?: FarmControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FarmDto>>> {
    const obs = farmControllerFindAll(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 전체 농가 목록 조회.
   *
   * 전체 농가 목록을 조회합니다. (드롭다운용)
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmControllerFindAll(params?: FarmControllerFindAll$Params, context?: HttpContext): Observable<Array<FarmDto>> {
    const resp = this.farmControllerFindAll$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<FarmDto>>): Array<FarmDto> => r.body)
    );
  }

  /** Path part for operation `farmControllerFindById()` */
  static readonly FarmControllerFindByIdPath = '/api/farm/{id}';

  /**
   * 농가 상세 조회.
   *
   * 농가를 ID로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmControllerFindById$Response(params: FarmControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmDto>> {
    const obs = farmControllerFindById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 농가 상세 조회.
   *
   * 농가를 ID로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmControllerFindById(params: FarmControllerFindById$Params, context?: HttpContext): Observable<FarmDto> {
    const resp = this.farmControllerFindById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FarmDto>): FarmDto => r.body)
    );
  }

  /** Path part for operation `farmControllerDelete()` */
  static readonly FarmControllerDeletePath = '/api/farm/{id}';

  /**
   * 농가 삭제.
   *
   * 농가를 삭제합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmControllerDelete$Response(params: FarmControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmDto>> {
    const obs = farmControllerDelete(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 농가 삭제.
   *
   * 농가를 삭제합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  farmControllerDelete(params: FarmControllerDelete$Params, context?: HttpContext): Observable<FarmDto> {
    const resp = this.farmControllerDelete$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FarmDto>): FarmDto => r.body)
    );
  }

  /** Path part for operation `farmControllerUpdate()` */
  static readonly FarmControllerUpdatePath = '/api/farm/{id}';

  /**
   * 농가 수정.
   *
   * 농가 정보를 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `farmControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmControllerUpdate$Response(params: FarmControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<FarmDto>> {
    const obs = farmControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 농가 수정.
   *
   * 농가 정보를 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `farmControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  farmControllerUpdate(params: FarmControllerUpdate$Params, context?: HttpContext): Observable<FarmDto> {
    const resp = this.farmControllerUpdate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<FarmDto>): FarmDto => r.body)
    );
  }

}
